import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { adminAPI } from '../../utils/api';
import { toast } from 'sonner';
import { Shield, Lock } from 'lucide-react';

const AdminLogin = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    
    if (!username || !password) {
      toast.error('Please enter username and password');
      return;
    }

    setLoading(true);
    try {
      const response = await adminAPI.login(username, password);
      login(response.data.token, 'admin', { username: response.data.username });
      toast.success('Login successful!');
      navigate('/admin/dashboard');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 to-slate-700 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-blue-600 mb-4">
            <Shield className="w-10 h-10 text-white" strokeWidth={2.5} />
          </div>
          <h1 className="text-3xl md:text-4xl font-bold tracking-tight uppercase text-white" style={{ fontFamily: 'Barlow Condensed, sans-serif' }}>
            ADMIN LOGIN
          </h1>
          <p className="text-sm font-medium tracking-wide uppercase text-slate-300 mt-2">
            Park Monitoring System
          </p>
        </div>

        <div className="bg-white rounded-lg shadow-xl p-6">
          <form onSubmit={handleLogin} className="space-y-6">
            <div>
              <label className="text-sm font-bold uppercase tracking-wider text-slate-700 mb-2 block">
                Username
              </label>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="h-14 px-4 w-full rounded-lg border-2 border-slate-300 focus:border-blue-600 focus:ring-0 text-lg bg-white"
                placeholder="admin"
                data-testid="admin-username-input"
              />
            </div>

            <div>
              <label className="text-sm font-bold uppercase tracking-wider text-slate-700 mb-2 block">
                Password
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="h-14 px-4 w-full rounded-lg border-2 border-slate-300 focus:border-blue-600 focus:ring-0 text-lg bg-white"
                placeholder="Enter password"
                data-testid="admin-password-input"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="h-14 w-full rounded-lg font-bold uppercase tracking-wide shadow-md hover:shadow-lg transition-all active:scale-95 text-lg bg-blue-600 text-white disabled:opacity-50"
              data-testid="admin-login-button"
            >
              {loading ? 'LOGGING IN...' : 'LOGIN'}
            </button>
          </form>

          <div className="mt-6 text-center">
            <button
              onClick={() => navigate('/inspector/login')}
              className="text-blue-600 font-semibold hover:underline"
            >
              Park Supervisor Login
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
